bq.contentGroupPopup = function(element, options) {
    this.options = options;
    this.$element = $(element);
    this.$tiles = this.$element.find(this.options.tilesSelector);
    this.$resultsCount = this.$element.find(this.options.resultsCountSelector);
    this.config = {};
    this.searchTimer = null;
    this.switching = false;
    this.initialized = false;
};

bq.contentGroupPopup.DEFAULTS = {
    configSelector: '.cg-popup-config',
    tilesSelector: '.cg-popup-tiles',
    resultsCountSelector: '.cg-popup-results-count',
    errorSelector: '.cg-popup-error',
    searchSelector: '.cg-popup-search input',
    tileSelector: '.cg-popup-tile',
    tileActionSelector: '.cg-popup-tile__action',
    openSelector: '[data-action="open-cg-popup"]',
    searchDelay: 200
};

bq.contentGroupPopup.prototype = {
    init: function() {
        if (this.initialized) {
            return;
        }

        this.config = this._getConfig();
        this._bindEvents();
        this.initialized = true;

        if (this.config.autoOpen) {
            this.$element.modal('show');
        }
    },

    _getConfig: function() {
        var configText = this.$element.find(this.options.configSelector).text();

        if (!configText) {
            return {};
        }

        try {
            return $.parseJSON(configText);
        } catch (error) {
            bq.debug.error('Content Group Popup : invalid configuration', error);
            return {};
        }
    },

    _bindEvents: function() {
        var context = this;

        $(document).on('click.contentGroupPopup', this.options.openSelector, function(event) {
            event.preventDefault();
            context.$element.modal('show');
        });

        this.$element.on('click.contentGroupPopup', this.options.tileSelector, function(event) {
            context._selectGroup(event);
        });

        this.$element.on('input.contentGroupPopup', this.options.searchSelector, function() {
            context._search($(this).val());
        });
    },

    _search: function(value) {
        var context = this;
        var query = value.toLowerCase().trim();

        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(function() {
            var groups = query
                ? context.config.groups.filter(function(group) {
                    return group.name.toLowerCase().indexOf(query) !== -1;
                })
                : context.config.groups;

            context._renderTiles(groups, query !== '');
        }, this.options.searchDelay);
    },

    _selectGroup: function(event) {
        var $selectedTile = $(event.currentTarget);

        event.preventDefault();

        if (this.switching) {
            event.stopImmediatePropagation();
            return;
        }

        this._hideError();
        this._startSwitching($selectedTile);
        this._selectGroupRequest($selectedTile);
    },

    _startSwitching: function($selectedTile) {
        this.switching = true;
        clearTimeout(this.searchTimer);

        var $otherTiles = this.$tiles.find(this.options.tileSelector).not($selectedTile);
        var $action = $selectedTile.find(this.options.tileActionSelector);
        var label = $selectedTile.hasClass('is-current')
            ? this.config.labels.continuing
            : this.config.labels.checking;

        $action.data('original-html', $action.html());
        this.$element
            .attr('aria-busy', 'true')
            .addClass('is-switching');
        this.$element.find(this.options.searchSelector).prop('disabled', true);
        $otherTiles
            .attr('aria-disabled', 'true')
            .attr('tabindex', '-1');
        $selectedTile
            .attr('aria-busy', 'true')
            .addClass('is-selected');
        this._setActionStatus($selectedTile, label);
    },

    _setActionStatus: function($selectedTile, label) {
        $selectedTile.find(this.options.tileActionSelector)
            .attr({
                'aria-live': 'polite',
                role: 'status'
            })
            .empty()
            .append($('<i>', {
                'class': 'fa fa-spinner fa-spin',
                'aria-hidden': 'true'
            }))
            .append(document.createTextNode(label));
    },

    _selectGroupRequest: function($selectedTile) {
        var context = this;
        var url = $selectedTile.attr('href') || $selectedTile.data('switch-url');

        $.ajax({
            url: url,
            type: 'POST',
            dataType: 'json',
            data: {
                form_key: this.config.formKey
            }
        }).done(function(response) {
            if (response && response.sessionExpired && response.redirectUrl) {
                $('body').trigger('bq.viewhandler.start');
                window.location.replace(response.redirectUrl);
                return;
            }

            if (!response || !response.success) {
                context._handleSelectionError(response, $selectedTile);
                return;
            }

            if (response.reload) {
                var redirectUrl = response.redirectUrl || window.location.href;

                context._setActionStatus($selectedTile, context.config.labels.switching);
                $('body').trigger('bq.viewhandler.start');
                window.setTimeout(function() {
                    window.location.assign(redirectUrl);
                }, 0);
                return;
            }

            context._resetSwitching($selectedTile);
            context.$element.modal('hide');
        }).fail(function() {
            context._handleSelectionError(null, $selectedTile);
        });
    },

    _handleSelectionError: function(response, $selectedTile) {
        if (response && $.isArray(response.groups)) {
            this.config.groups = response.groups;
            this.config.totalCount = response.totalCount;
            this.config.hasSearch = response.totalCount > this.config.maxTiles;
            this._renderTiles(response.groups, false);
            this._updateSearchVisibility();

            if (response.noGroups) {
                this.$resultsCount.empty();
            }
        }

        this._resetSwitching($selectedTile);
        this._showError(response && response.message
            ? response.message
            : this.config.labels.switchError);
    },

    _updateSearchVisibility: function() {
        var $search = this.$element.find(this.options.searchSelector).closest('.cg-popup-search');

        if (this.config.hasSearch) {
            $search.prop('hidden', false).show();
            return;
        }

        $search.prop('hidden', true).hide();
        $search.find('input').val('');
    },

    _resetSwitching: function($selectedTile) {
        var $action = $selectedTile.find(this.options.tileActionSelector);
        var originalHtml = $action.data('original-html');

        this.switching = false;
        this.$element
            .removeAttr('aria-busy')
            .removeClass('is-switching');
        this.$element.find(this.options.searchSelector).prop('disabled', false);
        this.$tiles.find(this.options.tileSelector)
            .removeAttr('aria-disabled tabindex aria-busy')
            .removeClass('is-selected');

        if (originalHtml) {
            $action.html(originalHtml).removeData('original-html');
        }
    },

    _showError: function(message) {
        this.$element.find(this.options.errorSelector)
            .text(message)
            .prop('hidden', false)
            .show();
    },

    _hideError: function() {
        this.$element.find(this.options.errorSelector)
            .prop('hidden', true)
            .hide()
            .empty();
    },

    _renderTiles: function(groups, hasQuery) {
        var visibleGroups = groups.slice(0, this.config.maxTiles);
        var fragment = document.createDocumentFragment();

        for (var i = 0; i < visibleGroups.length; i++) {
            fragment.appendChild(this._createTile(visibleGroups[i])[0]);
        }

        this.$tiles.empty().append(fragment);
        this._updateResultsCount(visibleGroups.length, groups.length, hasQuery);
    },

    _createTile: function(group) {
        var isCurrent = group.is_current;
        var $name = $('<div>', {
            'class': 'cg-popup-tile__name',
            text: group.name
        });
        var $logo = $('<div>', {'class': 'cg-popup-tile__logo'}).append(
            $('<img>', {
                src: group.logo_url || this.config.defaultLogo,
                alt: ''
            })
        );
        var $description = $('<div>', {
            'class': 'cg-popup-tile__description' + (group.description ? '' : ' is-empty'),
            text: group.description || ''
        });
        var $action = $('<span>', {'class': 'cg-popup-tile__action'})
            .text(this.config.labels.select + ' ')
            .append($('<i>', {
                'class': 'fa fa-long-arrow-right',
                'aria-hidden': 'true'
            }));
        var $tile;

        if (isCurrent) {
            $tile = $('<button>', {
                type: 'button',
                'class': 'cg-popup-tile is-current',
                'data-switch-url': group.switch_url,
                'aria-current': 'true',
                'aria-label': this._formatLabel(this.config.labels.selectGroup, [group.name])
            });
        } else {
            $tile = $('<a>', {
                href: group.switch_url,
                'class': 'cg-popup-tile',
                'aria-label': this._formatLabel(this.config.labels.selectGroup, [group.name])
            });
        }

        $tile
            .append($('<div>', {'class': 'cg-popup-tile__header'}).append($logo, $name))
            .append($description)
            .append($action);

        return $('<div>', {'class': 'col-sm-3 cg-popup-tile-column'}).append($tile);
    },

    _updateResultsCount: function(visibleCount, matchingCount, hasQuery) {
        var labels = this.config.labels;
        var label;

        if (!hasQuery) {
            label = matchingCount > this.config.maxTiles
                ? this._formatLabel(labels.showing, [visibleCount, matchingCount])
                : this._formatLabel(labels.total, [matchingCount]);
        } else if (matchingCount === 0) {
            label = this._formatLabel(labels.noMatches, [this.config.totalCount]);
        } else if (matchingCount > this.config.maxTiles) {
            label = this._formatLabel(labels.showingMatches, [visibleCount, matchingCount, this.config.totalCount]);
        } else {
            label = this._formatLabel(labels.matches, [matchingCount, this.config.totalCount]);
        }

        this.$resultsCount.text(label);
    },

    _formatLabel: function(label, values) {
        for (var i = 0; i < values.length; i++) {
            label = label.replace('%s', values[i]);
        }
        return label;
    }
};

var contentGroupPopupOld = $.fn.contentGroupPopup;

$.fn.contentGroupPopup = function(option, _relatedTarget) {
    return this.each(function() {
        var $this = $(this);
        var data = $this.data('bq.contentGroupPopup');
        var options = $.extend({}, bq.contentGroupPopup.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

        if (!data) {
            $this.data('bq.contentGroupPopup', (data = new bq.contentGroupPopup(this, options)));
        }
        data.init();
    });
};

$.fn.contentGroupPopup.Constructor = bq.contentGroupPopup;

$.fn.contentGroupPopup.noConflict = function() {
    $.fn.contentGroupPopup = contentGroupPopupOld;
    return this;
};

bq.contentGroupPopupInit = function() {
    $('[data-bq="content-group-popup"]').each(function() {
        var $element = $(this);

        if ($element.data('bq.contentGroupPopup')) {
            return;
        }
        $element.contentGroupPopup($element.data());
    });
};

bq.init.push(bq.contentGroupPopupInit);
